export const LOAD_GOOGLE_SCRIPT_ERROR_MESSAGE = 'Failed to load Google Pay script';
export default LOAD_GOOGLE_SCRIPT_ERROR_MESSAGE;
